import StoreConfirmationModal from 'components/store-confirmation-modal';

export default function StoreConfirmation() {
  return <StoreConfirmationModal />;
}
